import { css } from "@emotion/css";
import PageContent from "../../../../components/molecule/pageContent";
import { RiArrowTurnBackLine, RiArrowTurnForwardLine } from "@remixicon/react";
import { useEffect, useState } from "react";

const MemoriasDaAlmaOcultoHome = () => {
    
    const [lobbyAnchor, setLobbyAnchor] = useState(0);
    const [backButton, setBackButton] = useState([true, 0]);

    const isMobile = window.innerWidth < 500;
    
    const pageCSS = css`
        font-family: 'Source Code Pro', Arial;
    
        .kt-page-content {
            background-repeat: no-repeat;
            background-size: cover;
    
            &#first {
                background-image: url('/img/bg_5.jpeg');
                color: #fbf7ba;
                padding: 10%;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                flex-direction: column;
    
                div {
                    flex: 1;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
    
                    h1 {
                        font-weight: 300;
                        letter-spacing: 1rem;
                        font-size: ${isMobile ? "3.5rem" : "5.5rem"};
                    }
                        
                    h2 {
                        margin-top: 200px;
                        font-size: ${isMobile ? "4.5rem" : "6rem"};
                        font-family: "Monsieur La Doulaise", cursive;
                        font-weight: 400;
                    }
                }
    
                label {
                    background-color: #1b0a02;
                    box-sizing: border-box;
                    padding: 15px 0px 15px 1rem;
                    font-weight: 400;
                    letter-spacing: 1rem;
                    color: #ffffff;
                    width: 100%;
                    font-family: 'Fira Code', monospace;
                    text-align: center;
                    font-size: ${isMobile ? "1.5rem" : "2.5rem"};
                }
            }
    
            &#second {
                background-color: #dcd5cf;
                display: flex;
                flex-wrap: wrap;
                padding: 10%;
                box-sizing: border-box;
                align-items: center;
                gap: 50px;
    
                h1 {
                    font-size: ${isMobile ? "3.5rem" : "4rem"};
                    font-weight: 400;
                    letter-spacing: 1rem;
                }
    
                p {
                    font-size: ${isMobile ? "1.5rem" : "1.75rem"};
                    text-align: justify;
                    text-justify: inter-word;
                    max-width: 470px;
                }
    
                span {
                    background-image: url('/img/bg_5.jpeg');
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                    height: calc(98vh - 200px);
                    min-width: 200px;
                    flex: 1;
                }
    
            }
                
            &#third {
                background-image: url('/img/bg_5.jpeg');
                display: flex;
                align-items: center;
                justify-content: end;
                padding: 10%;
                box-sizing: border-box;

                p {
                    color: #fbf7ba;
                    font-size: ${isMobile ? "3rem" : "5.5rem"};
                    line-height: ${isMobile ? "2.75rem" : "5rem"};
                    text-align: end;
                    letter-spacing: 1rem;
                }
            }
                
            &#fourth {
                background-color: #dcd5cf;
                display: flex;
                align-items: center;
                padding: 10%;
                box-sizing: border-box;

                p {
                    font-size: ${isMobile ? "3.75rem" : "5.5rem"};
                    line-height: ${isMobile ? "3.25rem" : "5rem"};
                    letter-spacing: 1rem;
                }
            }
                    
            &#fifth {
                background-image: url('/img/bg_6.jpeg');
                background-position: center;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 50px;
                padding: 50px;
                box-sizing: border-box;

                p {
                    position: relative;
                    margin: 0;
                    color: #fbf7ba;
                    font-size: ${isMobile ? "2.5rem" : "5.5rem"};
                    line-height: ${isMobile ? "2.25rem" : "5rem"};
                    font-weight: 300;
                    letter-spacing: 1rem;

                    &::after {
                        content: '';
                        background-color: #fbf7ba;
                        position: absolute;
                        height: 3px;
                        width: 40%;
                        top: 30px;
                        right: 100px;
                    }
                }

                label {
                    color: #fbf7ba;
                    font-family: "Monsieur La Doulaise", cursive;
                    font-size: ${isMobile ? "3.5rem" : "4.5rem"};
                    text-align: end;
                }
            }
    
            &#sixth {
                background-color: #dcd5cf;
                                display: flex;
                flex-direction: column;
                gap: 200px;
                padding: 50px;
                box-sizing: border-box;

                p {
                    position: relative;
                    margin: 0;
                    font-size: ${isMobile ? "2.5rem" : "5.5rem"};
                    line-height: ${isMobile ? "2.25rem" : "5rem"};
                    font-weight: 300;
                    letter-spacing: 1rem;

                    &::after {
                        content: '';
                        background-color: #000000;
                        position: absolute;
                        height: 3px;
                        width: 40%;
                        top: 30px;
                        right: 100px;
                    }
                }

                label {
                    font-size: ${isMobile ? "1.5rem" : "2.5rem"};
                }
            }

            &#lobby {
                background-image: url('/img/bg_5.jpeg');
                padding: 10%;
                box-sizing: border-box;
                display: flex;
                gap: 50px;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;

                a {
                    flex: 1;
                    min-width: max-content;
                    text-decoration: none;
                    text-align: center;
                    background-color: #1b0a02;
                    padding: 15px;
                    color: #ffffff;
                    letter-spacing: 0.5rem;
                    box-sizing: border-box;
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    border: 1px solid #c39b54;
                    border-radius: 10px;
                    transition: 0.5s;

                    &:hover {
                        background-color: #c39b54;
                        color: #1b0a02;
                        transform: scale(1.05);
                        transition: 0.5s;
                    }
                }
            }
        }
    
        .kt-page-content-primary {
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            box-sizing: border-box;
            padding: 10%;
            padding-top: calc(10% + 100px);
    
            h1 {
                background-color: #1b0a02;
                box-sizing: border-box;
                padding: 15px 0px 15px 1rem;
                font-weight: 400;
                letter-spacing: 1rem;
                color: #ffffff;
                width: fit-content;
                font-family: 'Fira Code', monospace;
                text-align: center;
                font-size: ${isMobile ? "2.75rem" : "3.75rem"};
            }
    
            .brand {
                position: absolute;
                left: 10%;
                top: 10%;
                color: #ffffff;
                font-family: 'Fira Code', monospace;
                letter-spacing: 0.5rem;
                width: max-content;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                
                &::before {
                    content: 'ARQUIVO VIVO';
                    width: fit-content;
                    font-size: 1.75rem;
                }
                    
                &::after {
                    content: 'MEMÓRIAS DA ALMA';
                    width: fit-content;
                    font-size: .75rem;
                }
            }
    
            &#romance {
                background-image: url('/img/bg_7.jpeg');
            }
    
            &#reflexao {
                background-image: url('/img/bg_8.jpeg');
            }
    
            &#condicao {
                background-image: url('/img/bg_9.jpeg');
            }
    
            &#humana {
                background-image: url('/img/bg_9.jpeg');
            }
    
            &#filosofia {
                background-image: url('/img/bg_10.jpeg');
            }
    
            &#arte {
                background-image: url('/img/bg_11.jpeg');
            }
    
            &#leitura {
                background-image: url('/img/bg_12.jpeg');
            }
    
            &#carta {
                background-image: url('/img/bg_20.jpeg');
                display: flex;
                justify-content: end;
                align-items: end;
            }
        }
    
        .kt-page-content-secondary {
            text-align: center;
            font-family: 'Source Code Pro', Arial;
            font-weight: 500;
            font-size: 2rem;
            padding: 50px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            text-transform: uppercase;
    
            &::before {
                content: '';
                position: absolute;
                z-index: -1;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                background-repeat: no-repeat;
                background-size: cover;
                background-image: url('/img/bg_1.jpeg');
                background-position: center;
            }
    
            p {
                margin: 0;
                line-height: 2.5rem;
                color: #ffffff;
            }
        }

        #back-to-top {
            position: fixed;
            bottom: 20px;
            left: 20px;
            font-size: 2rem;
            color: #ffffff;
            cursor: pointer;
            background-color: #1b0a02;
            padding: 10px;
            border-radius: 50%;
            z-index: 1000;
            border: 1px solid #c39b54;
            opacity: 1;
            transition: 0.5s;

            &:hover {
                background-color: #c39b54;
                color: #1b0a02;
                transform: scale(1.05);
                transition: 0.5s;
            }
        }
    `;

    useEffect(() => {
        const lobbyElement = document.getElementById('lobby');
        if (lobbyElement) {
            setLobbyAnchor(lobbyElement.offsetTop);
        }

        window.addEventListener('scroll', () => {
            let hide = window.scrollY < (lobbyElement.offsetTop + 100) 
                && window.scrollY > (lobbyElement.offsetTop - 1000);

            if (window.scrollY >= (lobbyElement.offsetTop + 10)) {
                setBackButton((val) => [hide, -1]);
            } else if (window.scrollY <= (lobbyElement.offsetTop - 100)) {
                setBackButton((val) => [hide, 1]);
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<div className={pageCSS}>
        <PageContent id="first">
            <div>
                <h1>MEMÓRIAS</h1>
                <h2>Da Alma</h2>
            </div>
            <label>ARQUIVO VIVO</label>
        </PageContent>
        <PageContent id="second">
            <div>
                <h1>BEM-VINDO</h1>
                <p>
                    Se você chegou até aqui,
                    significa que alguma parte
                    desta história continua
                    VIVA depois da última página.
                </p>
            </div>
            <span />
        </PageContent>
        <PageContent id="third">
            <p>
                ESTE NÃO É UM<br/> 
                LUGAR PARA<br/>
                EXPLICAR O<br/>
                LIVRO
            </p>
        </PageContent>
        <PageContent id="fourth">
            <p>
                É UM LUGAR<br/>
                PARA AMPLIAR<br/>
                SEUS ECOS.
            </p>
        </PageContent>
        <PageContent id="fifth">
            <p>
                ALGUMAS<br/>
                RESPOSTAS<br/>
                TALVEZ ESTEJAM<br/>
                AQUI.<br/>
            </p>
            <label>
                Outras permanecerão...<br/>
                Apenas na Sua Alma.
            </label>
        </PageContent>
        <PageContent id="sixth">
            <p>
                ENTRE NO<br/>
                TEMPO<br/>
                CERTO.
            </p>
            <label>
                Cada porta revela uma<br/>
                nova camada desta<br/>
                jornada.
            </label>
        </PageContent>
        <PageContent id="lobby">
            <a href="/memorias-da-alma/oculto/home/#romance">O ROMANCE</a>
            <a href="/memorias-da-alma/oculto/home/#reflexao">A REFLEXÃO<br/>ESPIRITUAL</a>
            <a href="/memorias-da-alma/oculto/home/#humana">A CONDIÇÃO HUMANA</a>
            <a href="/memorias-da-alma/oculto/home/#filosofia">A FILOSOFIA DO AMOR</a>
            <a href="/memorias-da-alma/oculto/home/#arte">A ARTE COMO<br/>VESTÍGIO DA ALMA</a>
            <a href="/memorias-da-alma/oculto/home/#leitura">A LEITURA<br/>PSICOLÓGICA</a>
            {/* <a href="/memorias-da-alma/oculto/home/#carta">CARTA DA AUTORA</a> */}
            <a href="/memorias-da-alma/oculto/simbolos/#first">OS SÍMBOLOS</a>        
            <a href="/memorias-da-alma/oculto/vestigio/#first">VESTÍGIOS</a>
        </PageContent>
        <PageContent id="romance" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>O ROMANCE</h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                À primeira vista, Memórias da Alma pode parecer apenas<br/>
                uma história de amor.<br/><br/>

                E, de fato, ela é.<br/><br/>

                É a história de Cael e Lyra. Duas almas que atravessam o<br/>
                tempo, os sonhos, a saudade e o esquecimento tentando<br/>
                reencontrar uma à outra.<br/><br/>

                Mas, enquanto escrevia, percebi que o romance nunca foi<br/>
                realmente sobre o encontro.<br/><br/>

                Foi sobre a caminhada.<br/>
                Encontrar alguém pode acontecer em um instante.<br/>
                Permanecer exige escolha.<br/><br/>

                Todos nós, em algum momento da vida, encontramos<br/>
                pessoas que despertam algo difícil de explicar. Há olhares<br/>
                que parecem antigos. Conversas que parecem continuar de<br/>
                onde haviam parado. Presenças que nos fazem sentir em<br/>
                casa sem sabermos por quê.<br/><br/>

                Mas o reconhecimento, por si só, não basta.<br/>
                É a reciprocidade que transforma um encontro em caminho.<br/>
                É a entrega que transforma um instante em história.<br/><br/>

                Por isso, o maior conflito de Cael e Lyra nunca foi<br/>
                simplesmente encontrar um ao outro.<br/><br/>

                Foi escolher caminhar um em direção ao outro, mesmo<br/>
                quando o tempo, a distância, o medo e o esquecimento<br/>
                pareciam tornar esse caminho impossível.<br/><br/>

                Talvez seja assim também conosco.<br/>
                O amor não acontece apenas quando duas pessoas se<br/>
                encontram.<br/><br/>

                Ele acontece quando duas pessoas escolhem permanecer<br/>
                presentes uma para a outra.<br/><br/>

                Se, ao longo destas páginas, você enxergou apenas um<br/>
                romance, espero que ele tenha tocado seu coração.<br/><br/>

                Mas, se enxergou algo além, talvez tenha percebido que<br/>
                Cael e Lyra representam muito mais do que duas pessoas.<br/><br/>

                Representam toda busca humana por aquilo que<br/>
                reconhecemos antes mesmo de compreender.<br/><br/>

                Porque algumas histórias de amor não começam quando<br/>
                duas pessoas se encontram.<br/><br/>

                Elas começam quando duas almas decidem caminhar uma<br/>
                em direção à outra.
            </p>
        </PageContent>
        <PageContent id="reflexao" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>
                A REFLEXÃO<br/>
                ESPIRITUAL
            </h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Desde o início, Memórias da Alma nunca pretendeu explicar<br/>
                o invisível.<br/><br/>

                Pretendeu apenas contemplá-lo.<br/><br/>

                Este livro não foi escrito para afirmar como a realidade<br/>
                espiritual funciona, nem para defender uma doutrina ou<br/>
                oferecer respostas definitivas. Ele nasceu da contemplação<br/>
                de perguntas que acompanham a humanidade desde sempre.<br/><br/>

                De onde viemos?<br/><br/>

                Por que certas ausências parecem anteriores às nossas<br/>
                lembranças?<br/><br/>

                Por que algumas pessoas despertam em nós uma sensação<br/>
                de reconhecimento impossível de explicar?<br/><br/>

                E por que a alma parece carregar uma saudade que a<br/>
                própria memória não consegue nomear?<br/><br/>

                Ao longo da narrativa, a Origem, a separação, o retorno<br/>
                e a saudade aparecem como símbolos. Cada leitor lhes<br/>
                atribuirá um significado diferente. Para alguns, serão<br/>
                metáforas da condição humana. Para outros, reflexões<br/>
                sobre a alma. Para outros ainda, ecos da relação entre a<br/>
                criatura e o Criador.<br/><br/>

                Talvez toda busca humana seja, no fundo, uma tentativa<br/>
                de retornar àquilo que um dia sentimos como completo.<br/><br/>

                Alguns chamam essa busca de amor.<br/>
                Outros, de propósito.<br/>
                Outros, de paz.<br/>
                E talvez muitos a chamem de Deus.<br/><br/>

                Não importa o nome que escolhemos. O que importa é que<br/>
                existe, dentro de cada ser humano, um movimento<br/>
                silencioso em direção a algo maior do que si mesmo.<br/><br/>

                Foi esse movimento que inspirou este livro.<br/>
                Se, ao terminar estas páginas, você encontrou respostas,<br/>
                fico feliz.<br/><br/>

                Mas, se encontrou apenas novas perguntas, talvez tenha<br/>
                recebido um presente ainda maior.<br/><br/>

                Porque algumas respostas encerram uma busca.<br/>
                As perguntas certas, porém, têm o poder de transformar<br/>
                uma vida inteira.<br/><br/>

                Que esta história não lhe diga no que acreditar.<br/>
                Que apenas desperte, em você, o desejo de continuar<br/>
                procurando.
            </p>
        </PageContent>
        <PageContent id="humana" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>
                A CONDIÇÃO<br/>
                HUMANA
            </h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Talvez a pergunta mais profunda de Memórias da Alma nunca<br/>
                tenha sido: "Quem são Cael e Lyra?"<br/><br/>

                Talvez ela sempre tenha sido:<br/>
                "O que todos nós estamos procurando?"<br/>
                Existe um vazio que acompanha a experiência humana.<br/>
                Não é um vazio que se preenche com coisas, conquistas ou<br/>
                respostas rápidas.<br/><br/>

                É uma inquietação silenciosa.<br/>
                Uma sensação de que existe algo além do que já conhecemos.<br/>
                Por isso caminhamos.<br/><br/>

                Buscamos pessoas, lugares, sonhos, conhecimento, beleza, amor.<br/>
                Mudamos de cidade, de trabalho, de relacionamentos.<br/>
                Iniciamos novas jornadas acreditando que, talvez, no próximo<br/>
                passo encontraremos aquilo que nos falta.<br/><br/>

                Mas, muitas vezes, percebemos que a busca continua.<br/>
                Não porque tudo o que encontramos perdeu o valor, mas porque<br/>
                aquilo que procuramos é maior do que qualquer objeto ou<br/>
                experiência isolada.<br/><br/>

                Em Memórias da Alma, essa busca assume muitas formas.<br/>
                Ela aparece na saudade que não sabe explicar sua origem.<br/>
                No desejo de pertencer.<br/>
                Na necessidade de ser reconhecido.<br/><br/>

                Na esperança de encontrar um lugar que finalmente possa ser<br/>
                chamado de Casa.<br/><br/>

                Cada leitor poderá interpretar essa ausência de uma maneira<br/>
                diferente.<br/><br/>

                Para alguns, ela será a busca por um grande amor.<br/>
                Para outros, a procura pela própria identidade.<br/>
                Para outros ainda, a sede de encontrar Deus, um propósito ou<br/>
                um sentido para existir.<br/><br/>

                Talvez todas essas buscas sejam expressões de um mesmo anseio.<br/>
                O ser humano nunca deixa de procurar porque foi feito para<br/>
                caminhar.<br/><br/>

                A busca não revela apenas aquilo que desejamos encontrar.<br/>
                Ela revela quem estamos nos tornando ao longo do caminho.<br/>
                Talvez seja por isso que Cael e Lyra nunca representaram apenas<br/>
                duas pessoas.<br/><br/>

                Eles representam esse movimento permanente da alma humana:<br/>
                o desejo de reconhecer, de pertencer, de amar e de encontrar<br/>
                um lugar onde o coração finalmente possa descansar.<br/><br/>

                Se este livro permanecer com você depois da última página,<br/>
                talvez não seja porque respondeu às suas perguntas.<br/><br/>

                Talvez seja porque despertou uma que já existia dentro de você.<br/>
                E talvez a condição humana seja exatamente isso:<br/>
                Continuar caminhando, não porque sabemos todas as respostas, mas<br/>
                porque existe dentro de nós a esperança de que cada passo nos<br/>
                aproxime um pouco mais daquilo que, desde sempre, sentimos faltar.<br/><br/>

                Porque algumas buscas não existem para nos lembrar do que perdemos.<br/>
                Elas existem para nos conduzir àquilo que ainda estamos destinados<br/>
                a encontrar.
            </p>
        </PageContent>
        <PageContent id="filosofia" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>
                A FILOSOFIA<br/>
                DO AMOR
            </h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                O amor foi, talvez, a pergunta mais silenciosa enquanto<br/>
                escrevia este livro.<br/><br/>

                Não me interessava descrevê-lo como um sentimento passageiro,<br/>
                nem como um destino inevitável. Eu queria compreendê-lo como<br/>
                uma escolha. Como um caminho. Como uma forma de reconhecer a<br/>
                vida.<br/><br/>

                Ao longo da história, Cael e Lyra nos lembram que o amor não<br/>
                nasce no momento do encontro. O encontro apenas revela aquilo<br/>
                que já existia em silêncio.<br/><br/>

                Mas reconhecer alguém não basta.<br/>
                O reconhecimento aproxima.<br/>
                A reciprocidade escolhe.<br/>
                A entrega eterniza.<br/>
                Foi essa a filosofia que conduziu cada página.<br/><br/>

                Vivemos em um tempo em que o amor, muitas vezes, é confundido<br/>
                com posse, necessidade ou expectativa. Porém, enquanto escrevia,<br/>
                percebi que o verdadeiro amor não aprisiona. Ele convida.<br/>
                Não exige. Responde. Não domina. Cuida.<br/><br/>

                Talvez amar seja reconhecer a beleza da liberdade do outro e,<br/>
                ainda assim, escolher caminhar ao seu lado.<br/><br/>

                O amor, para mim, também é um ato de coragem.<br/>
                Coragem para permanecer quando seria mais fácil partir.<br/>
                Coragem para confiar quando não há garantias.<br/>
                Coragem para continuar oferecendo o coração, mesmo sabendo que<br/>
                toda entrega nos torna vulneráveis.<br/><br/>

                Por isso, este livro não fala apenas do amor entre duas pessoas.<br/>
                Fala do amor pela vida.<br/>
                Pela verdade.<br/>
                Pela arte.<br/><br/>

                Por aquilo que nos aproxima da nossa essência.<br/>
                E, para alguns, fala também do amor que nos conduz de volta à<br/>
                Origem.<br/><br/>

                Talvez, no fim, amar seja exatamente isso:<br/>
                Reconhecer aquilo que faz a alma recordar quem ela é.<br/>
                Se esta história deixou alguma marca em você, espero que não<br/>
                seja apenas a lembrança de um romance.<br/><br/>

                Espero que ela o convide a viver um amor que não se limita ao<br/>
                sentimento, mas que se transforma em presença, reciprocidade e<br/>
                entrega.<br/><br/>

                Porque o amor mais profundo não é aquele que apenas nos<br/>
                encontra.<br/><br/>

                É aquele que nos transforma.
            </p>
        </PageContent>
        <PageContent id="arte" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>
                A ARTE COMO<br/>
                VESTÍGIO DA ALMA
            </h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Há uma pergunta que me acompanhou durante toda a escrita<br/>
                deste livro:<br/><br/>

                E se a arte fosse a memória daquilo que a alma nunca<br/>
                conseguiu esquecer?<br/><br/>

                Talvez seja por isso que uma música nos faz chorar sem<br/>
                explicação.<br/><br/>

                Que um quadro nos prende por longos minutos.<br/>
                Que um poema parece contar uma história que nunca vivemos<br/>
                e, ainda assim, sentimos como nossa.<br/><br/>

                A arte possui esse mistério.<br/>
                Ela alcança lugares onde a razão não consegue entrar.<br/><br/>

                Em Memórias da Alma, os livros, as pinturas, a música, as<br/>
                flores e cada símbolo não foram escolhidos apenas por sua<br/>
                beleza. Eles representam vestígios. Marcas deixadas ao longo<br/>
                do caminho, como se a alma espalhasse pequenos sinais para um<br/>
                dia encontrar o caminho de volta.<br/><br/>

                Talvez seja isso que todo artista faça, mesmo sem perceber.<br/>
                Ele transforma em criação aquilo que não consegue guardar<br/>
                apenas dentro de si.<br/><br/>

                Cada obra é uma tentativa de dizer o indizível.<br/>
                Cada pintura procura dar forma ao invisível.<br/>
                Cada melodia tenta traduzir um silêncio.<br/><br/>

                Cada livro nasce da esperança de que, em algum lugar,<br/>
                alguém reconhecerá aquilo que também habita dentro de si.<br/><br/>

                A arte cria pontes entre pessoas que nunca se encontraram.<br/>
                Ela atravessa o tempo.<br/>
                Sobrevive aos seus criadores.<br/>
                Continua falando quando suas vozes já se calaram.<br/><br/>

                Talvez seja por isso que acredito que a arte nunca pertence<br/>
                inteiramente ao artista.<br/><br/>

                Ela apenas passa por ele.<br/>
                E, quando encontra outro coração disposto a acolhê-la,<br/>
                completa o seu percurso.<br/><br/>

                Se este livro despertou algo em você, talvez não tenha<br/>
                sido apenas pela história.<br/><br/>

                Talvez tenha sido porque, em algum momento, a sua alma<br/>
                reconheceu um vestígio deixado nestas páginas.<br/>
                E talvez seja esse o verdadeiro propósito da arte.<br/><br/>

                Não convencer.<br/>
                Não explicar.<br/>
                Mas recordar.<br/><br/>

                Recordar que, mesmo separados pelo tempo, pela distância<br/>
                ou pelas circunstâncias, ainda somos capazes de nos<br/>
                reconhecer através da beleza.<br/><br/>

                Porque toda obra de arte é, no fundo, uma carta silenciosa<br/>
                escrita por uma alma que acredita que, um dia, outra alma<br/>
                a encontrará.
            </p>
        </PageContent>
        <PageContent id="leitura" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>
                A LEITURA<br/>
                PSICOLÓGICA
            </h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Toda história pode ser lida como um espelho.<br/>
                E talvez esta seja uma das formas mais profundas de<br/>
                atravessar Memórias da Alma.<br/><br/>

                Se deixarmos de lado qualquer interpretação espiritual,<br/>
                Cael e Lyra deixam de ser apenas duas pessoas. Eles podem<br/>
                representar partes de uma mesma psique.<br/><br/>

                A parte que lembra.<br/>
                E a parte que esquece.<br/>
                A parte que busca.<br/>
                E a parte que teme encontrar.<br/><br/>

                Ao longo da narrativa, sonhos, símbolos, lugares e encontros<br/>
                podem ser compreendidos como manifestações do mundo interior.<br/><br/>

                A estação, as flores, a Casa, o relógio, a saudade... tudo<br/>
                pode ser visto como imagens da alma tentando comunicar aquilo<br/>
                que a consciência ainda não consegue expressar.<br/><br/>

                A psicologia nos mostra que nem tudo o que somos está<br/>
                acessível à razão. Há lembranças, desejos, medos e<br/>
                esperanças que permanecem em silêncio, esperando o momento<br/>
                certo para emergir.<br/><br/>

                Talvez seja por isso que alguns encontros nos transformam.<br/>
                Nem sempre reconhecemos apenas a outra pessoa.<br/>
                Às vezes, reconhecemos uma parte de nós que estava<br/>
                esquecida.<br/><br/>

                Talvez seja essa a verdadeira viagem de Cael e Lyra.<br/>
                Não apenas um caminho em direção ao outro.<br/>
                Mas um caminho de integração.<br/>
                Um retorno ao que estava fragmentado.<br/><br/>

                Ao terminar este livro, talvez você tenha sentido que<br/>
                algumas passagens falavam diretamente com você. Talvez<br/>
                certos símbolos tenham despertado emoções que pareciam não<br/>
                pertencer apenas à história.<br/><br/>
                
                A literatura possui esse poder.<br/>
                Ela nos permite encontrar, em personagens fictícios,<br/>
                verdades profundamente reais.<br/><br/>

                Nesse sentido, Cael e Lyra também habitam dentro de<br/>
                cada leitor.<br/><br/>

                Representam os conflitos entre razão e intuição, medo e<br/>
                coragem, ausência e presença, esquecimento e memória.<br/><br/>

                Mais do que responder quem somos, esta história talvez<br/>
                nos convide a fazer uma pergunta ainda mais importante:<br/><br/>

                Quais partes de mim ainda esperam ser reconhecidas?<br/>
                Talvez essa seja a maior contribuição da leitura psicológica.<br/>
                Perceber que, antes de qualquer reencontro com o outro,<br/>
                existe um reencontro silencioso que precisa acontecer dentro<br/>
                de nós.<br/><br/>

                E, quando isso acontece, descobrimos que algumas das<br/>
                jornadas mais longas não atravessam o mundo.<br/><br/>
                
                Atravessam o coração.
            </p>
        </PageContent>
        {/* <PageContent id="carta" className="kt-page-content-primary">
            <div className="brand"/>
            <h1>
                CARTA DA<br/>
                AUTORA
            </h1>
        </PageContent>
        <PageContent className="kt-page-content-secondary">
            <p>
                Este livro nasceu de um despertar.<br/>

                Durante muito tempo, pensei que carregava<br/>
                saudade de algo que havia perdido.<br/><br/>

                Só mais tarde compreendi que era saudade de mim.<br/>
                Da mulher que deixei para depois. Dos sonhos que<br/>
                adormeceram. Da presença que se perdeu entre as<br/>
                urgências da vida.<br/><br/>

                Escrever estas páginas foi um retorno. Retorno à minha<br/>
                essência. À minha fé. Ao olhar amoroso de Deus, que nunca<br/>
                deixou de me reconhecer como filha, mesmo quando eu já não<br/>
                conseguia me enxergar.<br/><br/>

                Não escrevi esta história para oferecer respostas.<br/>
                Escrevi porque acredito que, às vezes, um livro pode ser um<br/>
                espelho.<br/><br/>

                E talvez, enquanto percorre estas páginas, você também encontre<br/>
                algo que julgava perdido.<br/><br/>

                Ou, quem sabe...<br/>
                Encontre a si mesmo.<br/><br/><br/>

                Com reconhecimento e amor,<br/><br/>

                Maysa De Cesaro <br/><br/>
                ZYZA.<br/><br/>
                Junho, 2026.<br/><br/><br/><br/>
                Deixe rastros pelo mundo
            </p>
        </PageContent> */}
        {backButton[1] === -1 
            ? <RiArrowTurnForwardLine id="back-to-top" className={backButton[0] ? "kt-hidden" : ""} onClick={() => window.scrollTo(0, lobbyAnchor)}/>
            : <RiArrowTurnBackLine id="back-to-top" className={backButton[0] ? "kt-hidden" : ""} onClick={() => window.scrollTo(0, lobbyAnchor)}/>
        }
            
    </div>)
}
export default MemoriasDaAlmaOcultoHome;